import edit_button from "../edit_button.html";
import filter_genre_btn from "../filter_genre_btn.html";
import modalImage from "../../templates/modalTemplate.html";
import modalImageUpload from "../../templates/modalImageUpload.html";

export default function (nga, admin) {
  const subgenre = admin.getEntity("subgenres");
  subgenre
    .listView()
    .title(
      '<h4>Subgenres <i class="fa fa-angle-right" aria-hidden="true"></i> List</h4>'
    )
    .batchActions([])
    .fields([
      nga.field("id", "string").isDetailLink(true).label("ID"),
      nga.field("name", "string").label("Name"),

      nga
        .field("channels")
        .map(function total(value, entry) {
          var obj = [];
          for (var i = value.length - 1; i >= 0; i--) {
            obj[i] = value[i].total;
            return obj[i];
          }
        })
        .label("Number of Channels"),
    ])
    .listActions(["edit", "delete"])
    .exportFields([subgenre.listView().fields()]);

  subgenre
    .deletionView()
    .title(
      '<h4>Genre <i class="fa fa-angle-right" aria-hidden="true"></i> Remove <span style ="color:red;"> {{ entry.values.description }} </span></h4>'
    )
    .actions([
      '<ma-back-button entry="entry" entity="entity"></ma-back-button>',
    ]);

  subgenre
    .creationView()
    .title(
      '<h4>Subgenre <i class="fa fa-angle-right" aria-hidden="true"></i> Create: Genre</h4>'
    )
    .fields([
      nga
        .field("name", "string")
        .attributes({ placeholder: "Name of the channel genre/category" })
        .validation({ required: true })
        .label("Name"),

      nga.field("template").label("").template(edit_button),
    ]);

  subgenre
    .editionView()
    .title(
      '<h4>Genres <i class="fa fa-angle-right" aria-hidden="true"></i> Edit: {{ entry.values.name }}</h4>'
    )
    .actions(["list"])
    .fields([
      subgenre.creationView().fields(),
      nga
        .field("", "referenced_list")
        .label("Channel")
        .targetEntity(admin.getEntity("Channels"))
        .targetReferenceField("subgenre_id")
        .targetFields([
          nga.field("channel_number").label("Nr"),
          nga.field("icon_url", "file").template(modalImage).label("Icon"),
          nga
            .field("title", "string")
            .attributes({ placeholder: "Title" })
            .validation({ required: true })
            .label("Title"),
        ])
        .listActions(["edit"]),
      nga.field("template").label("").template(filter_genre_btn),
    ]);

  return subgenre;
}



// WEBPACK FOOTER //
// ./js/subgenre/config.js